var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _rect6, _circle5, _circle6, _circle7, _g, _circle8, _circle9, _circle0, _g2, _rect7, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVhsCassette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 460,
    viewBox: "0 0 720 460",
    role: "img",
    "aria-label": "\\u0412\\u0438\\u0434\\u0435\\u043E\\u043A\\u0430\\u0441\\u0441\\u0435\\u0442\\u0430 VHS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 640,
    height: 380,
    rx: 24,
    fill: "#2E2E38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 76,
    width: 568,
    height: 150,
    rx: 10,
    fill: "#F6F7F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 112,
    width: 220,
    height: 14,
    rx: 7,
    fill: "#458FF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 140,
    width: 340,
    height: 10,
    rx: 5,
    fill: "#92929D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 164,
    width: 260,
    height: 10,
    rx: 5,
    fill: "#92929D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 8,
    fill: "#F6F7F8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 656,
    cy: 64,
    r: 8,
    fill: "#F6F7F8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 396,
    r: 8,
    fill: "#F6F7F8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 656,
    cy: 396,
    r: 8,
    fill: "#F6F7F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 252,
    width: 568,
    height: 128,
    rx: 10,
    fill: "#1F1F27"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 316,
    r: 58,
    fill: "#F6F7F8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 316,
    r: 30,
    fill: "#1F1F27"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 316,
    r: 10,
    fill: "#F6F7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1F1F27",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 286,
    x2: 230,
    y2: 346
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 316,
    x2: 260,
    y2: 316
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209,
    y1: 295,
    x2: 251,
    y2: 337
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251,
    y1: 295,
    x2: 209,
    y2: 337
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 316,
    r: 58,
    fill: "#F6F7F8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 316,
    r: 30,
    fill: "#1F1F27"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 316,
    r: 10,
    fill: "#F6F7F8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#1F1F27",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 286,
    x2: 490,
    y2: 346
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 316,
    x2: 520,
    y2: 316
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469,
    y1: 295,
    x2: 511,
    y2: 337
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511,
    y1: 295,
    x2: 469,
    y2: 337
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 308,
    width: 160,
    height: 16,
    fill: "#1F1F27"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#FC724D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 392,
    width: 36,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 392,
    width: 36,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 392,
    width: 36,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 392,
    width: 36,
    height: 16,
    rx: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhsCassette);
export default __webpack_public_path__ + "static/media/vhs-cassette.d37bd23f5650487d8e3b2f8a13569111.svg";
export { ForwardRef as ReactComponent };